import React from "react";
import { Link } from "react-router-dom";
import hero from "../resources/download.png";

function Hero() {
  return (
    <section className="relative min-h-[92vh] flex items-center justify-center overflow-hidden bg-black">
      {/* Background image with zoom animation */}
      <div className="absolute inset-0">
        <img
          src={hero}
          alt=""
          className="absolute inset-0 w-full h-full object-cover animate-slow-zoom"
        />
        {/* Layered gradients for depth */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/40 to-transparent"></div>
        <div className="absolute inset-0 bg-radial-fade opacity-80"></div>
        <div className="absolute inset-0 noise opacity-[0.06] mix-blend-overlay"></div>
      </div>

      {/* Grid pattern overlay */}
      <div className="absolute inset-0 bg-grid-pattern bg-[size:60px_60px] opacity-20"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 py-20 w-full">
        <div className="max-w-3xl">
          <h1 className="reveal font-chivo text-white text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-black leading-[0.95] tracking-tight">
            WELCOME TO
            <br />
            <span className="gradient-text">BINI AUTOREPAIR INC</span>
          </h1>

          <p className="reveal reveal-delay-1 mt-8 text-lg md:text-2xl text-zinc-200 font-montserrat max-w-xl font-light leading-relaxed">
            We offer you quality repairs with{" "}
            <span className="font-bold text-white">25+ years</span> of
            experience!
          </p>

          {/* CTAs */}
          <div className="reveal reveal-delay-2 mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Link to="/services">
              <button className="group relative overflow-hidden rounded-full px-8 py-4 bg-gradient-to-r from-brand-500 to-brand-700 text-white font-semibold shadow-glow hover:shadow-[0_0_40px_-5px_rgba(225,29,72,0.9)] transition-all hover:scale-[1.03]">
                <span className="relative z-10 flex items-center gap-3">
                  Explore Services
                  <i className="fa-solid fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
                </span>
              </button>
            </Link>
            <a href="tel:+13475820864">
              <button className="group rounded-full px-8 py-4 bg-white/5 backdrop-blur-md border border-white/15 text-white font-semibold hover:bg-white/10 hover:border-white/30 transition-all">
                <span className="flex items-center gap-3">
                  <i className="fa-solid fa-phone text-brand-400"></i>
                  Call (347) 582-0864
                </span>
              </button>
            </a>
          </div>

          {/* Stats */}
          <div className="reveal reveal-delay-3 mt-16 grid grid-cols-3 gap-4 md:gap-8 max-w-xl">
            {[
              { value: "25+", label: "Years Experience" },
              { value: "100%", label: "Quality Service" },
              { value: "NYC", label: "Local & Trusted" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="border-l-2 border-brand-500 pl-3 md:pl-5"
              >
                <div className="text-white text-2xl md:text-4xl font-black font-chivo">
                  {stat.value}
                </div>
                <div className="text-zinc-400 text-[10px] md:text-xs uppercase tracking-wider mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-2 text-white/60">
        <span className="text-[10px] uppercase tracking-[0.3em]">Scroll</span>
        <div className="w-px h-10 bg-gradient-to-b from-white/60 to-transparent"></div>
      </div>
    </section>
  );
}

export default Hero;
